import { useContext } from 'react';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';

const useAction = (
	params: any
): {
	creditKindWinnings: () => Promise<void>;
} => {
	const { showAlert } = useContext(AppContext);
	const { handleRewardModalOpen, rowData = EMPTY_OBJECT } = params;

	const creditKindWinnings = async (): Promise<void> => {
		try {
			handleRewardModalOpen(rowData);
		} catch (error) {
			showAlert('Error in crediting kind winnings to the user!', { type: 'error' });
		}
	};

	return {
		creditKindWinnings
	};
};

export default useAction;
